import {StrMap} from "../interfaces/common";

const breadcrumbConfig: Array<StrMap> = [
    { path: '/', breadcrumbKey: 'home' },
    { path: '/development-plan', breadcrumbKey: 'development-plan-nav-title' },
    { path: '/accept_invite/:code', breadcrumbKey: 'accept-invite' },
    { path: '/feedback/questionnaire/:id', breadcrumbKey: 'feedback-questionnaire' },

    // video coach
    {path: '/videocoach', breadcrumbKey: 'video-coach-nav-title'},
    {path: '/videocoach/my-coach', breadcrumbKey: 'my-coach'},
    {path: '/videocoach/chat/:coachId', breadcrumbKey: 'Chat'},
    {path: '/videocoach/book-meeting', breadcrumbKey: 'book-meeting-nav-title'},
  ];
  
  export default breadcrumbConfig;